import { Component, EventListener, triggerPublicEvent } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';
import { IGOverlayHandlerOptions } from '@swisslife/shared-types/src/types/gondel-public-events';

enum Selectors {
	Item = '.js-m-product-comparison__item',
	Button = '.js-m-product-comparison__trigger-overlay',
	Title = '.js-m-product-comparison__title',
}

// The @Component decorator will connect the class with `data-g-name="ProductComparison"` elements.
@Component('ProductComparison')
export class ProductComparison extends GondelJqueryComponent {
	private controllers: any[] = Array();
	private controllersTitle: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx, Selectors.Item);
		this.controllersTitle = await addComponentAnimation(this.$ctx, Selectors.Title);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
		for (const controller of this.controllersTitle) {
			controller.destroy(true);
		}
	}

	@EventListener('click', Selectors.Button)
	private _handleButtonClick(ev: MouseEvent) {
		ev.preventDefault();

		const $target = $(ev.currentTarget!);

		const eventOptions: IGOverlayHandlerOptions = {
			overlayComponent: 'ProductComparison',
			overlayTitle: $target.data('overlay-title') || '',
			overlayContentUrl: $target.data('overlay-content-url') || '',
		};

		triggerPublicEvent('gOverlayHandler', this, undefined, eventOptions);
	}
}
